import numeral from 'numeral';
// load a locale
numeral.register('locale', 'id', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'Rb', // Ribu
    million: 'Jt', // Juta
    billion: 'M', // Miliar
    trillion: 'T', // Triliun
  },
  ordinal: () => {
    return '.';
  },
  currency: {
    symbol: 'Rp', // Rupiah
  },
});
numeral.locale('id');
